import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TerminalPassengerSelfServiceIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14 13L19.155 7L24 8V23H14V13ZM4.14797 6.727C4.36497 5.913 4.87797 5.491 6.01597 5.512C6.68797 5.524 7.24797 5.84 7.69597 6.496L8.72797 8.08C9.1456 8.80145 9.74035 9.40446 10.456 9.832C11.2229 10.2957 12.1038 10.5367 13 10.528V12.496C11.9612 12.5031 10.9334 12.2834 9.98834 11.8523C9.04324 11.4212 8.20359 10.789 7.52797 10L6.90397 13L9.01597 15.016V22.528H6.99997V16.528L5.00297 14.512V22.528H2.82397L2.92197 12.87L3.80797 8.416L4.14797 6.727ZM7.52797 4.984C7.26553 4.98679 7.00516 4.93729 6.76205 4.8384C6.51894 4.7395 6.29795 4.59319 6.11197 4.408C5.91984 4.2311 5.76712 4.01573 5.66374 3.77589C5.56036 3.53606 5.50865 3.27714 5.51197 3.016C5.51197 2.472 5.71197 2 6.11197 1.6C6.51197 1.2 6.98397 1 7.52797 1C8.07197 1 8.54397 1.204 8.94397 1.612C9.34398 2.02 9.54397 2.488 9.54397 3.016C9.54397 3.544 9.33997 4.004 8.93197 4.396C8.52397 4.788 8.05597 4.984 7.52797 4.984Z'
                fill='currentColor'
            />
        </>
    ),
})

TerminalPassengerSelfServiceIcon.displayName = 'TerminalPassengerSelfServiceIcon'
